(() => {
  "use strict";
  document.addEventListener("DOMContentLoaded", function () {
    const horizontalScroll = document.getElementById("js-horizontal-scroll");

    if (horizontalScroll) {
      let isDragging = false;
      let startX = 0;
      let scrollStart = 0;

      // 共通の開始処理
      function onDragStart(clientX) {
        isDragging = true;
        startX = clientX - horizontalScroll.offsetLeft;
        scrollStart = horizontalScroll.scrollLeft;
        horizontalScroll.style.cursor = "grabbing";
      }

      // 共通の移動処理
      function onDragMove(clientX) {
        if (!isDragging) return;
        const x = clientX - horizontalScroll.offsetLeft;
        const walk = (x - startX) * 1.5;
        horizontalScroll.scrollLeft = scrollStart - walk;
      }

      // 共通の終了処理
      function onDragEnd() {
        isDragging = false;
        horizontalScroll.style.cursor = "grab";
      }

      // PC: マウスイベント
      horizontalScroll.addEventListener("mousedown", (e) => onDragStart(e.pageX));
      horizontalScroll.addEventListener("mousemove", (e) => {
        if (isDragging) {
          e.preventDefault();
          onDragMove(e.pageX);
        }
      });
      horizontalScroll.addEventListener("mouseup", onDragEnd);
      horizontalScroll.addEventListener("mouseleave", onDragEnd);

      // モバイル: タッチイベント
      horizontalScroll.addEventListener("touchstart", (e) => onDragStart(e.touches[0].pageX));
      horizontalScroll.addEventListener("touchmove", (e) => onDragMove(e.touches[0].pageX));
      horizontalScroll.addEventListener("touchend", onDragEnd);
    }
  });
})();
